import React, { useRef, useState, useMemo, useEffect } from 'react'
import {
  Row,
  Modal,
  ModalFooter,
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Nav,
  NavLink,
  NavItem,
  TabContent,
  TabPane
} from "reactstrap";
import { Colxx } from "../../components/common/CustomBootstrap";
import classnames from "classnames";
import CustomDropzone from "./CustomDropZone";
import JoditEditor from 'jodit-react'
import { resizeImage, rgbToHex } from "../../helpers/Utils"
import _axios from "../../libs/axios";
import { NotificationManager } from "../../components/common/react-notifications";

const Editor = props => {
  // console.log(props)
  const editor = useRef(null)
  let [content] = useState(props.value)
  const buttons = ['source','|','bold','strikethrough','underline','italic','ul','ol','font','fontsize','brush','align','paragraph','table','link']
  let config = {
    theme: localStorage.getItem("__theme_color")?.indexOf("dark") > -1 ? "dark" : "",
    toolbarButtonSize: 'medium',
    enableDragAndDropFileToEditor: false,
    readonly: props.disabled,
    toolbarAdaptive: true,
    showXPathInStatusbar: false,
    showCharsCounter: false,
    showWordsCounter: false,
    askBeforePasteHTML: false,
    placeholder: props.placeholder?? '...',
    language: 'es',
    buttons: buttons,
    buttonsMD: buttons,
    buttonsXS: buttons,
    /*
    controls: {
      align: {
        command: 'align',
        list: {
          left: 'left',
          right: 'right',
          center: 'center'
        }
      }
    },
    */
    extraButtons: [
      {
        name: 'insertImage',
        icon: 'image',
        exec: (editor) => {
          props.openFile(editor)
        }
      },
      /*
      {
        name: 'insertVideo',
        icon: 'video',
        exec: function (editor) {
          props.toggle(editor)
          // editor.s.insertHTML((new Date()).toDateString());
          // editor.s.insertImage('https://miracomosehace.com/wp-content/uploads/2020/05/hombre-gorra-camara-1.jpg', {width: '300px', height: ''});
        }
      }
      */
    ],
    /*
    uploader: {
      insertImageAsBase64URI: true
    },
    */
    events: {
      afterRemoveNode: (node) => {
        if (node.nodeName === 'IMG') {
          // console.log(node.src)
          props.deleteFile(node.src)
        }
      },
      afterInsertImage: (e) => {
        // console.log('afterInsertImage', e)
      },
      paste: (e) => {
        console.log(e)
      }
    }
  }

  if (props.aiAssist) {
    config.extraButtons.push(
      {
        name: 'AI',
        exec: (editor) => {
          props.aiAssist(editor)
        }
      }
    )
  }

  // equal to componentDidMount
  useEffect(() => {
    // console.log('montado')
  }, []);

  let handleChange = (val) => {
    const d = document.createElement('div')
    d.innerHTML = val;
    const tables = d.getElementsByTagName('table')

    for (let i = 0; i < tables.length; i++) {
      tables[i].style.border = 'none'
      tables[i].style.borderCollapse = 'collapse'
      tables[i].style.marginBottom = '20px'
      tables[i].style.marginTop = '20px'
      // tables[i].style.maxWidth = '100%'
      // tables[i].style.width = '100%'

      const cells = tables[i].getElementsByTagName('td')

      for (let j = 0; j < cells.length; j++) {
        let borderColor = rgbToHex(cells[j].style.borderColor)
        cells[j].style.border = '1px solid ' + (borderColor || '#cdcdcd')
        if (cells[j].style.backgroundColor) cells[j].style.backgroundColor = rgbToHex(cells[j].style.backgroundColor)
        if (cells[j].style.color) cells[j].style.color = rgbToHex(cells[j].style.color)
        cells[j].style.minWidth = '32px'
        cells[j].style.padding = cells[j].style.padding || '6px'
      }
    }
    
    function cerrarEtiquetasImg(texto) {
      const regex = /<img[^>]*>/gi;
      return texto.replace(regex, (match) => {
        if (match.endsWith("/>")) {
          return match; // La etiqueta ya está cerrada
        } else {
          return match.slice(0, -1) + " />"; // Agregar el cierre si no está presente
        }
      });
    }

    val = cerrarEtiquetasImg(d.innerHTML)
    // val = d.innerHTML
    // console.log(val)
    props.onChange(val)
  }

  return useMemo(() => (
    <JoditEditor ref={editor} value={content} config={config} onChange={handleChange}/>
    // eslint-disable-next-line			
  ), [])
}

class CustomEditor extends React.Component {
  constructor(props) {
    // console.log(props)
    super(props);
    this.refInputFile = React.createRef();
    this.toggleTab = this.toggleTab.bind(this);
    this.state = {
      isOpen: false,
      editor: null,
      activeTab: "1",
      name: '',
      file: null
    };
  }

  componentDidUpdate(prevProps) {
    // if (this.props.aiAssist && this.props.value) this.state.editor.s.insertHTML(this.props.value)
  }

  toggle = (editor) => {
    if (editor) this.setState({editor: editor})
    this.setState({isOpen: !this.state.isOpen})
  }

  toggleTab (tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  openFile = (editor) => {
    if (editor) this.setState({editor: editor})
    this.refInputFile.current.click()
  }

  uploadFile (file) {
    _axios
    .post('misc/content/file', {data: file})
    .then(r => {
      if (r.status === 0) {
        this.state.editor.execCommand('insertLineBreak')
        this.state.editor.s.insertImage(r.data.url, {width: '300px', height: ''})
      } else NotificationManager.error(r.msg, "Error", 5000, null, null, 'outline')
    })
    .catch((e) => {})
  }

  deleteFile (name) {
    _axios
    .post('misc/content/file/delete', {name: name})
    .then(r => {
    })
    .catch((e) => {})
  }

  handleOnChange = (e) => {
    let reader = new FileReader()
    reader.onload = () => {
      resizeImage(reader.result).then((r) => {
        // console.log(r)
        this.refInputFile.current.value = ''
        this.uploadFile(r)
      })
    }
    reader.readAsDataURL(e.target.files[0])
  }

  save = () => {
    this.state.editor.s.insertImage('https://miracomosehace.com/wp-content/uploads/2020/05/hombre-gorra-camara-1.jpg', {width: '300px', height: ''});
    this.toggle()
  }

  aiAssist = (editor) => {
    this.props.aiAssist(editor)
  }

  render() {
    return (
      <div id={this.props.id} >
        <Editor
          name={this.props.name}
          value={this.props.value}
          placeholder={this.props.placeholder}
          onChange={this.props.onChange}
          toggle={this.toggle}
          openFile={this.openFile}
          deleteFile={this.deleteFile}
          disabled={this.props.disabled}
          aiAssist={this.props.aiAssist ? this.aiAssist : null}
        ></Editor>

        <input type="file" ref={this.refInputFile} onChange={this.handleOnChange} accept=".jpg" style={{display: 'none'}}/>

        <Modal
          isOpen={this.state.isOpen}
          size="sm"
          toggle={this.toggle}
          centered={true}
        >

          <Card>
            <CardHeader className="pl-0 pr-0">
              <Nav tabs className="card-header-tabs  ml-0 mr-0">
                <NavItem className="w-50 text-center">
                  <NavLink
                    className={classnames({
                      active: this.state.activeTab === "1",
                      "nav-link": true
                    })}
                    onClick={() => {
                      this.toggleTab("1");
                    }}
                    to="#"
                  >
                    CARGAR IMAGEN
                  </NavLink>
                </NavItem>
                <NavItem className="w-50 text-center">
                  <NavLink
                    className={classnames({
                      active: this.state.activeTab === "2",
                      "nav-link": true
                    })}
                    onClick={() => {
                      this.toggleTab("2");
                    }}
                    to="#"
                  >
                    URL IMAGEN
                  </NavLink>
                </NavItem>
              </Nav>
            </CardHeader>

            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <Row>
                  <Colxx sm="12">
                    <CardBody>
                      <CardTitle className="mb-4">
                      <CustomDropzone
                        name={this.state.name}
                        opts={{}}
                        value={this.state.img}
                        onChange={this.handleChange}
                        uploadFiles={this.props.uploadFiles}
                      />
                      </CardTitle>
                    </CardBody>
                  </Colxx>
                </Row>
              </TabPane>
              <TabPane tabId="2">
                <Row>
                  <Colxx sm="12">
                    <CardBody>
                      <CardTitle className="mb-4">
                        Dos...
                      </CardTitle>
                    </CardBody>
                  </Colxx>
                </Row>
              </TabPane>
            </TabContent>
          </Card>

          <ModalFooter className="p-3">
            <Button color="primary" size="sm" onClick={() => { this.save() }}>Guardar</Button>
            <Button outline color="secondary" size="sm" onClick={() => { this.toggle()}}>Cancelar</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
};

export default CustomEditor